import { useRef } from 'react';

const features = [
  {
    icon: 'ri-flight-takeoff-line',
    title: 'Flights',
    desc: 'International & domestic airfare included',
  },
  {
    icon: 'ri-car-line',
    title: 'Transfers',
    desc: 'Private airport & hotel transfers',
  },
  {
    icon: 'ri-map-2-line',
    title: 'Tours & Activities',
    desc: 'Guided tours across Chile\'s top destinations',
  },
  {
    icon: 'ri-shield-check-line',
    title: 'Travel Insurance',
    desc: 'Full coverage for a worry-free journey',
  },
];

export default function FullExperienceBanner() {
  const handleBookNow = () => {
    const contactSection = document.getElementById('contacto');
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative overflow-hidden py-0">
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/26e423549f4e6cb5244b17b9ff36e2f4.jpg"
          alt="Chile Full Experience"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/75 via-black/55 to-black/30"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-8 py-12 md:py-20">
        <div className="flex flex-col lg:flex-row items-center gap-10 md:gap-14">
          {/* Left: Text */}
          <div className="flex-1 text-white">
            <span className="inline-block text-xs font-semibold tracking-widest uppercase bg-teal-500/30 border border-teal-400/50 text-teal-200 px-4 py-1.5 rounded-full mb-5">
              All-Inclusive Package
            </span>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-extrabold leading-tight mb-5">
              Your Complete<br />
              <span className="text-teal-300">Chile Experience</span>
            </h2>
            <p className="text-white/80 text-sm md:text-base leading-relaxed mb-8 max-w-lg">
              From the Atacama Desert to the glaciers of Patagonia — we handle every detail so you can focus on the adventure. Flights, transfers, expert-guided tours, and full travel insurance, all in one seamless package.
            </p>

            {/* Feature pills */}
            <div className="flex flex-wrap gap-3 mb-10">
              {features.map((f) => (
                <div
                  key={f.title}
                  className="flex items-center gap-2 bg-white/10 backdrop-blur-sm border border-white/20 rounded-full px-4 py-2"
                >
                  <div className="w-5 h-5 flex items-center justify-center text-teal-300">
                    <i className={`${f.icon} text-base`}></i>
                  </div>
                  <span className="text-sm font-medium text-white whitespace-nowrap">{f.title}</span>
                </div>
              ))}
            </div>

            <button
              onClick={handleBookNow}
              className="inline-flex items-center justify-center gap-3 bg-teal-500 hover:bg-teal-400 text-white font-bold px-6 md:px-8 py-3 md:py-4 rounded-full transition-all duration-300 shadow-lg hover:shadow-teal-500/40 hover:scale-105 cursor-pointer whitespace-nowrap text-sm md:text-base w-full sm:w-auto"
            >
              <span>Book Your Full Experience</span>
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-arrow-right-line text-lg"></i>
              </div>
            </button>
          </div>

          {/* Right: Feature cards */}
          <div className="flex-shrink-0 grid grid-cols-2 gap-3 md:gap-4 w-full max-w-sm">
            {features.map((f) => (
              <div
                key={f.title}
                className="bg-white/10 backdrop-blur-md border border-white/20 rounded-2xl p-4 md:p-5 flex flex-col gap-3 hover:bg-white/15 transition-all duration-300"
              >
                <div className="w-10 h-10 flex items-center justify-center bg-teal-500/30 rounded-xl">
                  <i className={`${f.icon} text-teal-300 text-xl`}></i>
                </div>
                <div>
                  <p className="text-white font-semibold text-sm mb-1">{f.title}</p>
                  <p className="text-white/65 text-xs leading-snug">{f.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}